module.exports = __webpack_public_path__ + "static/media/path5.fdb7bf12.jpg";